<template>
  <Layout>
    <div>
      <h1>My Profile</h1>
      
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header">
              <h3>Personal Information</h3>
            </div>
            <div class="card-body">
              <!-- 个人信息展示区 -->
              <!-- <div class="mb-4">
                <h5>个人信息</h5>
                <table class="table table-bordered table-sm">
                  <tbody>
                    <tr><th>Title</th><td>{{ profile.title }}</td></tr>
                    <tr><th>First Name</th><td>{{ profile.first_name }}</td></tr>
                    <tr><th>Last Name</th><td>{{ profile.last_name }}</td></tr>
                    <tr><th>Email</th><td>{{ profile.email }}</td></tr>
                    <tr><th>Alternative Email</th><td>{{ profile.alternative_email }}</td></tr>
                    <tr><th>Organization</th><td>{{ profile.organization }}</td></tr>
                    <tr><th>Job Title</th><td>{{ profile.job_title }}</td></tr>
                    <tr><th>Country</th><td>{{ profile.country }}</td></tr>
                    <tr><th>Birth Year</th><td>{{ profile.birth_year }}</td></tr>
                    <tr><th>Gender</th><td>{{ profile.gender }}</td></tr>
                    <tr><th>Telephone</th><td>{{ profile.telephone }}</td></tr>
                  </tbody>
                </table>
              </div> -->
              <form @submit.prevent="updateProfile">
                <div class="row">
                  <div class="col-md-6">
                    <!-- <div class="form-group">
                      <label for="title">Title</label>
                      <select class="form-control" id="title" v-model="profile.title">
                        <option value="">Select Title</option>
                        <option value="Mr">Mr</option>
                        <option value="Ms">Ms</option>
                        <option value="Dr">Dr</option>
                        <option value="Prof">Prof</option>
                      </select>
                    </div> -->
                  </div>
                  <div class="col-md-6"></div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="first_name">First Name</label>
                      <input 
                        type="text" 
                        class="form-control" 
                        id="first_name" 
                        v-model="profile.first_name"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="last_name">Last Name</label>
                      <input 
                        type="text" 
                        class="form-control" 
                        id="last_name" 
                        v-model="profile.last_name"
                      >
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="email">Email</label>
                      <input 
                        type="email" 
                        class="form-control" 
                        id="email" 
                        v-model="profile.email"
                        readonly
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="title">Title</label>
                      <select class="form-control" id="title" v-model="profile.title">
                        <option value="">Select Title</option>
                        <option value="Mr">Mr</option>
                        <option value="Ms">Ms</option>
                        <option value="Dr">Dr</option>
                        <option value="Prof">Prof</option>
                      </select>
                    </div>
                    <!-- <div class="form-group">
                      <label for="alternative_email">Alternative Email</label>
                      <input 
                        type="email" 
                        class="form-control" 
                        id="alternative_email" 
                        v-model="profile.alternative_email"
                      >
                    </div> -->
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="organization">Organization</label>
                      <input 
                        type="text" 
                        class="form-control" 
                        id="organization" 
                        v-model="profile.organization"
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="job_title">Job Title</label>
                      <JobTitleSelect v-model="profile.job_title" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="country">Country</label>
                      <CountrySelect v-model="profile.country" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="birth_year">Birth Year</label>
                      <input 
                        type="number" 
                        class="form-control" 
                        id="birth_year" 
                        v-model="profile.birth_year"
                        min="1900" max="2100"
                      >
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="gender">Gender</label>
                      <GenderSelect v-model="profile.gender" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="telephone">Telephone</label>
                      <input 
                        type="tel" 
                        class="form-control" 
                        id="telephone" 
                        v-model="profile.telephone"
                      >
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <button type="submit" class="btn btn-primary" :disabled="loading">
                    {{ loading ? 'Updating...' : 'Update Profile' }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        
        <div class="col-md-4">
          <div class="card">
            <div class="card-header">
              <h4>Account Information</h4>
            </div>
            <div class="card-body">
              <!-- <p><strong>Member ID:</strong> {{ profile.memberId }}</p> -->
              <p><strong>Member Since:</strong> {{ profile.memberSince }}</p>
              <p><strong>Status:</strong> <span class="badge badge-success">{{ profile.status }}</span></p>
              
              <hr>
              
              <h5>Quick Actions</h5>
              <div class="list-group">
                <router-link to="/change-password" class="list-group-item list-group-item-action">
                  Change Password
                </router-link>
                <router-link to="/my-abstracts" class="list-group-item list-group-item-action">
                  My Abstracts
                </router-link>
                <router-link to="/invoices" class="list-group-item list-group-item-action">
                  My Invoices
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue'
import { apiService } from '@/config/api'
import CountrySelect from '@/components/CountrySelect.vue'
import GenderSelect from '@/components/GenderSelect.vue'
import JobTitleSelect from '@/components/JobTitleSelect.vue'

export default {
  name: 'Profile',
  components: {
    Layout,
    CountrySelect,
    GenderSelect,
    JobTitleSelect
  },
  data() {
    return {
      profile: {
        title: 'Mr',
        first_name: 'Mr teacher',
        last_name: 'meng',
        email: 'teacher.meng@example.com',
        organization: 'University of Science and Technology',
        country: 'CN',
        birth_year: '1990',
        gender: 'Male',
        alternative_email: 'teacher.meng@example.com',
        job_title: 'Professor',
        telephone: '+86 123 4567 8900',
        memberId: 'AOGS2025001',
        memberSince: 'January 2020',
        status: 'Active'
      },
      loading: false
    }
  },
  mounted() {
    this.getProfile()
  },
  methods: {
    async getProfile() {
      const response = await apiService.auth.getProfile()
      this.profile = response.data.data
    },
    
    async updateProfile() {
      this.loading = true
      try {
        const response = await apiService.auth.updateProfile(this.profile)
        
        alert('Profile updated successfully')
      } catch (error) {
        console.error('Profile update failed:', error)
        alert('Update failed, please try again')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.card-header {
  background-color: #3498DB;
  color: white;
}

.form-group {
  margin-bottom: 1rem;
}

.list-group-item {
  border: none;
  border-bottom: 1px solid #eee;
}

.list-group-item:last-child {
  border-bottom: none;
}
</style> 